import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';

import { theme as customTheme, BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { CloseButton } from './core/CloseButton';
import { Overlay } from './Overlay';

const ModalContainer = styled('div')<IThemeProps>`
  width: 100%;
  height: 100%;
  color: black;
  overflow: auto;
  background: white;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    position: relative;
    width: 590px;
    height: auto;
    max-height: 90vh;
  }
`;

const overlayStyles = css`
  background: ${customTheme.colors.overlayTransparentBackground};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const closeButtonStyles = css`
  z-index: 2;
  position: absolute;
  top: 45px;
  right: 28px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 28px;
  }
`;

interface IRequestMeetingModalProps {
  children: ReactNode;
  onClose: () => void;
}

export const RequestMeetingModal: FC<IRequestMeetingModalProps> = ({ children, onClose }) => {
  return (
    <Overlay css={overlayStyles}>
      <ModalContainer>
        <CloseButton css={closeButtonStyles} onClose={onClose} variant="dark" size="small" />
        {children}
      </ModalContainer>
    </Overlay>
  );
};
